import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { obterExtratoBeneficios, obterExtratoConsignado, obterTiposBeneficiosDisponiveis } from '../../api/beneficioAPI';
import { obterNumeroFamiliarPorCPFIntegrante } from '../../api/familiaAPI';
import { RootState } from '../../app/store';
import * as mensagens from '../../common/Mensagens';

export interface BeneficiosState {
  extratoBeneficios: any;
  extratoConsignado: any;
  familia: any;
  beneficioSelecionado: any;
  tiposBeneficios: any;

  dataInicial: any;
  dataFinal: any;

  mensagem: string;
  tipoMensagem: string;
  ativarMensagem: boolean;
  mensagemPendeciaAvRev: any;

  ativarMensagemConsignado: boolean;
  tipoMensagemConsignado: string;
  mensagemConsignado: string;
}

const initialState: BeneficiosState = {
  extratoBeneficios: null,
  extratoConsignado: null,
  familia: null,
  beneficioSelecionado: 0,
  tiposBeneficios: null,
  dataInicial: new Date(),
  dataFinal: new Date(),
  mensagem: '',
  tipoMensagem: '',
  ativarMensagem: false,
  mensagemPendeciaAvRev: null,
  ativarMensagemConsignado: false,
  tipoMensagemConsignado: '',
  mensagemConsignado: ''
};

export const obterExtratoBeneficio = createAsyncThunk('beneficios/obterExtratoBeneficio', async (dados: any) => {
  return obterExtratoBeneficios(dados);
});

export const obterFamilia = createAsyncThunk('beneficios/obterFamilia', async (cpf: string) => {
  return obterNumeroFamiliarPorCPFIntegrante(cpf);
}
);

export const obterTiposBeneficios = createAsyncThunk('beneficios/obterTiposBeneficiosDisponiveis', async (dados: any) => {
  return obterTiposBeneficiosDisponiveis(dados);
});

export const obterExtratoConsignados = createAsyncThunk('beneficios/obterExtratoConsignado', async (dados: any) => {
  return obterExtratoConsignado(dados);
});

export const beneficiosSlice = createSlice({
  name: 'beneficiosSlice',
  initialState,
  reducers: {
    alterarBeneficioSelecionado: (state, action) => {
      state.beneficioSelecionado = action.payload;
    },
    limpar: (state) => {
      state.extratoBeneficios = initialState.extratoBeneficios;
      state.beneficioSelecionado = initialState.beneficioSelecionado;
      state.familia = initialState.familia;
      state.tiposBeneficios = null;
    },
    limparTiposBeneficios: (state) => {
      state.tiposBeneficios = null;
    },
    limparConsignados: (state) => {
      state.extratoConsignado = null;
    },
    ativarMensagem: (state, action) => {
      state.ativarMensagem = action.payload;
    },
    alterarMensagem: (state, action) => {
      state.mensagem = action.payload;
    },
    ativarMensagemConsignado: (state, action) => {
      state.ativarMensagemConsignado = action.payload;
    },
    alterarMensagemConsignado: (state, action) => {
      state.mensagemConsignado = action.payload;
    },
    alterarDataInicial: (state, action) => {
      state.dataInicial = action.payload;
    },
    alterarDataFinal: (state, action) => {
      state.dataFinal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(obterExtratoConsignados.fulfilled, (state, action) => {
        state.extratoConsignado = action.payload;
      })
      .addCase(obterExtratoBeneficio.fulfilled, (state, action) => {
        state.extratoBeneficios = action.payload;
      })
      .addCase(obterFamilia.fulfilled, (state, action) => {
        state.familia = action.payload.familia;
      })
      .addCase(obterTiposBeneficios.fulfilled, (state, action) => {
        state.tiposBeneficios = action.payload;
      })
      .addCase(obterTiposBeneficios.rejected, (state, error) => {
        state.ativarMensagem = true;

        if (error.error.message === mensagens.MSG_TENTE_NOVAMENTE) {
          state.tipoMensagem = 'error';
          state.mensagem = mensagens.MSG_TENTE_NOVAMENTE;
        }
      })
      .addCase(obterExtratoConsignados.rejected, (state, error) => {
        state.ativarMensagemConsignado = true;

        if (error.error.message === mensagens.MSG_TENTE_NOVAMENTE) {
          state.tipoMensagemConsignado = 'error';
          state.mensagemConsignado = mensagens.MSG_TENTE_NOVAMENTE;
        }
      })
  },
});

export const { alterarBeneficioSelecionado, limpar, limparTiposBeneficios, ativarMensagem, alterarMensagem,
  ativarMensagemConsignado, alterarMensagemConsignado, limparConsignados,
  alterarDataInicial, alterarDataFinal  } = beneficiosSlice.actions;

export const selectExtratoBeneficios = (state: RootState) => state.beneficios.extratoBeneficios;
export const selectTiposBeneficios = (state: RootState) => state.beneficios.tiposBeneficios;
export const selectFamilia = (state: RootState) => state.beneficios.familia;
export const selectBeneficioSelecionado = (state: RootState) => state.beneficios.beneficioSelecionado;
export const selectExtratoConsignado = (state: RootState) => state.beneficios.extratoConsignado;

export const selectState = (state: RootState) => state.beneficios;

export default beneficiosSlice.reducer;
